/**
 * Contains actions for transaction async calls.
 */
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import * as queryString from 'query-string';
import {api} from '../helpers/api';
import {getLangCode, stringBundle} from '../stringBundle';
import utils from '../helpers/utils';

export const TRANSACTION_LIST_REQUEST = 'TRANSACTION_LIST_REQUEST';
export const TRANSACTION_LIST_SUCCESS = 'TRANSACTION_LIST_SUCCESS';
export const TRANSACTION_OVERVIEW_SUCCESS = 'TRANSACTION_OVERVIEW_SUCCESS';
export const TRANSACTION_LIST_FAILURE = 'TRANSACTION_LIST_FAILURE';

export const MEMBER_ENROLLMENT_REQUEST = 'MEMBER_ENROLLMENT_REQUEST';
export const MEMBER_ENROLLMENT_SUCCESS = 'MEMBER_ENROLLMENT_SUCCESS';
export const MEMBER_ENROLLMENT_FAILURE = 'MEMBER_ENROLLMENT_FAILURE';

export const MEMBER_ACCOUNTS_REQUEST = 'MEMBER_ACCOUNTS_REQUEST';
export const MEMBER_ACCOUNTS_SUCCESS = 'MEMBER_ACCOUNTS_SUCCESS';
export const MEMBER_ACCOUNTS_FAILURE = 'MEMBER_ACCOUNTS_FAILURE';

export const FINANCIAL_INSTITUTIONS_REQUEST = 'FINANCIAL_INSTITUTIONS_REQUEST';
export const FINANCIAL_INSTITUTIONS_SUCCESS = 'FINANCIAL_INSTITUTIONS_SUCCESS';
export const FINANCIAL_INSTITUTIONS_FAILURE = 'FINANCIAL_INSTITUTIONS_FAILURE';

export const FINANCIAL_INSTITUTIONS_BY_ID_REQUEST = 'FINANCIAL_INSTITUTIONS_BY_ID_REQUEST';
export const FINANCIAL_INSTITUTIONS_BY_ID_SUCCESS = 'FINANCIAL_INSTITUTIONS_BY_ID_SUCCESS';
export const FINANCIAL_INSTITUTIONS_BY_ID_FAILURE = 'FINANCIAL_INSTITUTIONS_BY_ID_FAILURE';

export const POPULAR_FINANCIAL_INSTITUTIONS_REQUEST = 'POPULAR_FINANCIAL_INSTITUTIONS_REQUEST';
export const POPULAR_FINANCIAL_INSTITUTIONS_SUCCESS = 'POPULAR_FINANCIAL_INSTITUTIONS_SUCCESS';
export const POPULAR_FINANCIAL_INSTITUTIONS_FAILURE = 'POPULAR_FINANCIAL_INSTITUTIONS_FAILURE';

export const PAGINATE_TRANSACTIONS = 'PAGINATE_TRANSACTIONS';
export const FILTERED_TRANSACTIONS_BY_ACCOUNT_ID = 'FILTERED_TRANSACTIONS_BY_ACCOUNT_ID';
export const CURRENT_DATE_SELECTION = 'CURRENT_DATE_SELECTION';
export const CURRENT_ACCOUNT_SELECTION = 'CURRENT_ACCOUNT_SELECTION';

export const RESET_ADD_ACCOUNTS_MODAL = 'RESET_ADD_ACCOUNTS_MODAL';
export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';
export const RESET_LOGIN_ERROR = 'RESET_LOGIN_ERROR';
export const RESET_CHALLENGE_QUESTION = 'RESET_CHALLENGE_QUESTION';

export const TXM_SET_ALERT_PREF_REQUEST = 'TXM_SET_ALERT_PREF_REQUEST';
export const TXM_SET_ALERT_PREF_SUCCESS = 'TXM_SET_ALERT_PREF_SUCCESS';
export const TXM_SET_ALERT_PREF_FAILURE = 'TXM_SET_ALERT_PREF_FAILURE';

export const ADD_INSTITUTION_LOGIN_REQUEST = 'ADD_INSTITUTION_LOGIN_REQUEST';
export const ADD_INSTITUTION_LOGIN_SUCCESS = 'ADD_INSTITUTION_LOGIN_SUCCESS';
export const ADD_INSTITUTION_LOGIN_FAILURE = 'ADD_INSTITUTION_LOGIN_FAILURE';
export const ADD_INSTITUTION_LOGIN_AUTH_FAILURE = 'ADD_INSTITUTION_LOGIN_AUTH_FAILURE';

export const ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_REQUEST = 'ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_REQUEST';
export const ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_SUCCESS = 'ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_SUCCESS';
export const ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_FAILURE = 'ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_FAILURE';

export const ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_REQUEST = 'ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_REQUEST';
export const ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_SUCCESS = 'ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_SUCCESS';
export const ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_FAILURE = 'ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_FAILURE';

export const UPDATE_INSTITUTION_LOGIN_REQUEST = 'UPDATE_INSTITUTION_LOGIN_REQUEST';
export const UPDATE_INSTITUTION_LOGIN_SUCCESS = 'UPDATE_INSTITUTION_LOGIN_SUCCESS';
export const UPDATE_INSTITUTION_LOGIN_FAILURE = 'UPDATE_INSTITUTION_LOGIN_FAILURE';
export const UPDATE_INSTITUTION_LOGIN_AUTH_FAILURE = 'UPDATE_INSTITUTION_LOGIN_AUTH_FAILURE';

export const DELETE_INSTITUTION_LOGIN_REQUEST = 'DELETE_INSTITUTION_LOGIN_REQUEST';
export const DELETE_INSTITUTION_LOGIN_SUCCESS = 'DELETE_INSTITUTION_LOGIN_SUCCESS';
export const DELETE_INSTITUTION_LOGIN_FAILURE = 'DELETE_INSTITUTION_LOGIN_FAILURE';

export const SEARCH_FINANCIAL_INSTITUTION_REQUEST = 'SEARCH_FINANCIAL_INSTITUTION_REQUEST';
export const SEARCH_FINANCIAL_INSTITUTION_SUCCESS = 'SEARCH_FINANCIAL_INSTITUTION_SUCCESS';
export const SEARCH_FINANCIAL_INSTITUTION_FAILURE = 'SEARCH_FINANCIAL_INSTITUTION_FAILURE';

export const GET_ACCESS_TOKEN_REQUEST = 'GET_ACCESS_TOKEN_REQUEST';
export const GET_ACCESS_TOKEN_SUCCESS = 'GET_ACCESS_TOKEN_SUCCESS';
export const GET_ACCESS_TOKEN_ERROR = 'GET_ACCESS_TOKEN_ERROR';

const localizedStringBundle = stringBundle(getLangCode());

function addInstitutionLoginRequest() {
  return {
    type: ADD_INSTITUTION_LOGIN_REQUEST
  };
}

function addInstitutionLoginSuccess(payload) {
  let addInstitutionLoginResponse = {};

  if (!_isEmpty(payload)) {
    addInstitutionLoginResponse.statusCode = '0';
    addInstitutionLoginResponse.accounts = _get(payload, 'accounts', {});
    addInstitutionLoginResponse.challengeType = _get(payload, 'challengeType', '');
    addInstitutionLoginResponse.challengeQuestion = _get(payload, 'challengeQuestion', []);
    addInstitutionLoginResponse.challengeQuestions = _get(payload, 'challengeQuestions', []);
    addInstitutionLoginResponse.challengeToken = _get(payload, 'challengeToken', {});
    addInstitutionLoginResponse.challengeImage = _get(payload, 'challengeImage', {});
    addInstitutionLoginResponse.memSiteAccountId = _get(payload, 'memSiteAccountId', "");
    addInstitutionLoginResponse.messageCode = _get(payload, 'messageCode', "");
    addInstitutionLoginResponse.timeout = _get(payload, 'timeout', '');
  }

  if (!_isEmpty(payload.error)) {
    const statusCode = _get(payload.error, 'statusCode');
    const memSiteAccountId = _get(payload.error, 'memSiteAccountId');
    addInstitutionLoginResponse.statusCode = statusCode;
    addInstitutionLoginResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: ADD_INSTITUTION_LOGIN_SUCCESS,
    addInstitutionLoginResponse
  };
}

function addInstitutionLoginFailure(error) {
  let addInstitutionLoginResponse = {};

  if (!_isEmpty(error)) {
    const statusCode = _get(error, 'statusCode');
    const memSiteAccountId = _get(error, 'memSiteAccountId');
    addInstitutionLoginResponse.statusCode = statusCode;
    addInstitutionLoginResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: ADD_INSTITUTION_LOGIN_FAILURE,
    addInstitutionLoginResponse,
    error,
  }
}

function answerAddInstitutionLoginChallengeRequest() {
  return {
    type: ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_REQUEST
  }
}

function answerAddInstitutionLoginChallengeSuccess(payload) {
  let answerAddInstitutionLoginChallengeResponse = {};

  if (!_isEmpty(payload)) {
    answerAddInstitutionLoginChallengeResponse.statusCode = '0';
    answerAddInstitutionLoginChallengeResponse.challengeType = _get(payload, 'challengeType', '');
    answerAddInstitutionLoginChallengeResponse.challengeQuestion = _get(payload, 'challengeQuestion', '');
    answerAddInstitutionLoginChallengeResponse.challengeQuestions = _get(payload, 'challengeQuestions', '');
    answerAddInstitutionLoginChallengeResponse.challengeImage = _get(payload, 'challengeImage', '');
    answerAddInstitutionLoginChallengeResponse.challengeToken = _get(payload, 'challengeToken', '');
    answerAddInstitutionLoginChallengeResponse.accounts = _get(payload, 'accounts', '');
    answerAddInstitutionLoginChallengeResponse.memSiteAccountId = _get(payload, 'memSiteAccountId', '');
    answerAddInstitutionLoginChallengeResponse.messageCode = _get(payload, 'messageCode', '');
    answerAddInstitutionLoginChallengeResponse.timeout = _get(payload, 'timeout', '');
  }

  if (!_isEmpty(payload.error)) {
    const statusCode = _get(payload.error, 'statusCode');
    const memSiteAccountId = _get(payload.error, 'memSiteAccountId');
    answerAddInstitutionLoginChallengeResponse.statusCode = statusCode;
    answerAddInstitutionLoginChallengeResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_SUCCESS,
    answerAddInstitutionLoginChallengeResponse,
  }
}

function answerAddInstitutionLoginChallengeFailure(error) {
  let answerAddInstitutionLoginChallengeResponse = {};

  if (!_isEmpty(error)) {
    const statusCode = _get(error, 'statusCode');
    const memSiteAccountId = _get(error, 'memSiteAccountId');
    answerAddInstitutionLoginChallengeResponse.statusCode = statusCode;
    answerAddInstitutionLoginChallengeResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: ANSWER_ADD_INSTITUTION_LOGIN_CHALLENGE_FAILURE,
    answerAddInstitutionLoginChallengeResponse,
    error
  }
}

function updateInstitutionLoginRequest() {
  return {
    type: UPDATE_INSTITUTION_LOGIN_REQUEST
  };
}

function updateInstitutionLoginSuccess(payload) {
  let updateInstitutionLoginResponse = {};

  if (!_isEmpty(payload)) {
    updateInstitutionLoginResponse.statusCode = '0';
    updateInstitutionLoginResponse.accounts = _get(payload, 'accounts', {});
    updateInstitutionLoginResponse.challengeType = _get(payload, 'challengeType', '');
    updateInstitutionLoginResponse.challengeQuestion = _get(payload, 'challengeQuestion', []);
    updateInstitutionLoginResponse.challengeQuestions = _get(payload, 'challengeQuestions', []);
    updateInstitutionLoginResponse.challengeToken = _get(payload, 'challengeToken', {});
    updateInstitutionLoginResponse.challengeImage = _get(payload, 'challengeImage', {});
    updateInstitutionLoginResponse.memSiteAccountId = _get(payload, 'memSiteAccountId', "");
    updateInstitutionLoginResponse.messageCode = _get(payload, 'messageCode', "");
    updateInstitutionLoginResponse.timeout = _get(payload, 'timeout', '');
  }

  if (!_isEmpty(payload.error)) {
    const statusCode = _get(payload.error, 'statusCode');
    const memSiteAccountId = _get(payload.error, 'memSiteAccountId');
    updateInstitutionLoginResponse.statusCode = statusCode;
    updateInstitutionLoginResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: UPDATE_INSTITUTION_LOGIN_SUCCESS,
    updateInstitutionLoginResponse
  };
}

function updateInstitutionLoginFailure(error) {
  let updateInstitutionLoginResponse = {};

  if (!_isEmpty(error)) {
    const statusCode = _get(error, 'statusCode');
    const memSiteAccountId = _get(error, 'memSiteAccountId');
    updateInstitutionLoginResponse.statusCode = statusCode;
    updateInstitutionLoginResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: UPDATE_INSTITUTION_LOGIN_FAILURE,
    updateInstitutionLoginResponse,
    error
  }
}

function answerUpdateInstitutionLoginChallengeRequest() {
  return {
    type: ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_REQUEST
  }
}

function answerUpdateInstitutionLoginChallengeSuccess(payload) {
  let answerUpdateInstitutionLoginChallengeResponse = {};

  if (!_isEmpty(payload)) {
    answerUpdateInstitutionLoginChallengeResponse.statusCode = '0';
    answerUpdateInstitutionLoginChallengeResponse.challengeType = _get(payload, 'challengeType', '');
    answerUpdateInstitutionLoginChallengeResponse.challengeQuestion = _get(payload, 'challengeQuestion', '');
    answerUpdateInstitutionLoginChallengeResponse.challengeQuestions = _get(payload, 'challengeQuestions', '');
    answerUpdateInstitutionLoginChallengeResponse.challengeImage = _get(payload, 'challengeImage', '');
    answerUpdateInstitutionLoginChallengeResponse.challengeToken = _get(payload, 'challengeToken', '');
    answerUpdateInstitutionLoginChallengeResponse.accounts = _get(payload, 'accounts', '');
    answerUpdateInstitutionLoginChallengeResponse.memSiteAccountId = _get(payload, 'memSiteAccountId', '');
    answerUpdateInstitutionLoginChallengeResponse.messageCode = _get(payload, 'messageCode', '');
    answerUpdateInstitutionLoginChallengeResponse.timeout = _get(payload, 'timeout', '');
  }

  if (!_isEmpty(payload.error)) {
    const statusCode = _get(payload.error, 'statusCode');
    const memSiteAccountId = _get(payload.error, 'memSiteAccountId');
    answerUpdateInstitutionLoginChallengeResponse.statusCode = statusCode;
    answerUpdateInstitutionLoginChallengeResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_SUCCESS,
    answerUpdateInstitutionLoginChallengeResponse,
  }
}

function answerUpdateInstitutionLoginChallengeFailure(error) {
  let answerUpdateInstitutionLoginChallengeResponse = {};

  if (!_isEmpty(error)) {
    const statusCode = _get(error, 'statusCode');
    const memSiteAccountId = _get(error, 'memSiteAccountId');
    answerUpdateInstitutionLoginChallengeResponse.statusCode = statusCode;
    answerUpdateInstitutionLoginChallengeResponse.memSiteAccountId = memSiteAccountId;
  }

  return {
    type: ANSWER_UPDATE_INSTITUTION_LOGIN_CHALLENGE_FAILURE,
    answerUpdateInstitutionLoginChallengeResponse,
    error
  }
}

function deleteInstitutionLoginRequest() {
  return {
    type: DELETE_INSTITUTION_LOGIN_REQUEST
  };
}

function deleteInstitutionLoginSuccess(payload) {
  return {
    type: DELETE_INSTITUTION_LOGIN_SUCCESS,
    payload,
  };
}

function deleteInstitutionLoginFailure(error) {
  return {
    type: DELETE_INSTITUTION_LOGIN_FAILURE,
    error,
  };
}

function transactionListRequest() {
  return {
    type: TRANSACTION_LIST_REQUEST
  };
}

function transactionListSuccess(payload) {
  let transactions = {};
  let transactionsCount = 0;
  let lastUpdated = "";

  if (!_isEmpty(payload)) {
    transactions = payload.transactions;
    transactionsCount = payload.totalRowCount;

    if (!_isEmpty(transactions)) {
      if (Array.isArray(transactions) && transactions[0].postedDate) {
        lastUpdated = `${localizedStringBundle.TRANSACTIONS_LAST_UPDATED_TEXT}: ${utils.convertDateToString(transactions[0].postedDate)}`;
      }
      else if (transactions.postedDate) {
        lastUpdated = `${localizedStringBundle.TRANSACTIONS_LAST_UPDATED_TEXT}: ${utils.convertDateToString(transactions.postedDate)}`;
      }
    }
  }

  if (!transactions) {
    transactions = payload.message;
  }

  if (_isEmpty(transactions)) {
    transactions = {noResults: "No transactions found"};
  }

  return {
    type: TRANSACTION_LIST_SUCCESS,
    transactionList: transactions,
    transactionsCount,
    lastUpdated
  };
}

function transactionListSuccess4Overview(payload) {
  let transactions = {};
  if (!_isEmpty(payload)) {
    transactions = payload.transactions;
    if (!transactions) {
      transactions = payload.message;
    }

    if (_isEmpty(transactions)) {
      transactions = {noResults: "No transactions found"};
    }
  }

  return {
    type: TRANSACTION_OVERVIEW_SUCCESS,
    transactionList4Overview: transactions
  };
}

function transactionListFailure(error) {
  return {
    type: TRANSACTION_LIST_FAILURE,
    error,
  };
}

function memberAccountsRequest() {
  return {
    type: MEMBER_ACCOUNTS_REQUEST,
  };
}

function memberAccountsSuccess(payload) {
  let institutionsList = [];
  let alertPreferences = [];

  if (!_isEmpty(payload)) {
    institutionsList = _get(payload, 'institutions', []);
    alertPreferences = _get(payload, 'alertPreferences', []);
  }

  if (_isEmpty(institutionsList)) {
    institutionsList = {noResults: "No institutions available for this user"};
  }

  return {
    type: MEMBER_ACCOUNTS_SUCCESS,
    institutionsList,
    alertPreferences
  };
}

function memberAccountsFailure(error) {
  return {
    type: MEMBER_ACCOUNTS_FAILURE,
    error,
  };
}

function financialInstitutionsRequest() {
  return {
    type: FINANCIAL_INSTITUTIONS_REQUEST
  };
}

function financialInstitutionsSuccess(payload) {
  let financialInstitutions = {};

  if (!_isEmpty(payload)) {
    financialInstitutions = payload.institutions;
  }
  else if (!_isEmpty(payload.message)) {
    financialInstitutions = payload.message;
  }

  if (_isEmpty(financialInstitutions)) {
    financialInstitutions = {noResults: "No financial institutions retrieved."};
  }

  if (Array.isArray(financialInstitutions) && financialInstitutions.length === 0) {
    financialInstitutions = {noResults: "No financial institutions retrieved."};
  }

  return {
    type: FINANCIAL_INSTITUTIONS_SUCCESS,
    financialInstitutions
  };
}

function financialInstitutionsFailure(error) {
  return {
    type: FINANCIAL_INSTITUTIONS_FAILURE,
    error,
  };
}

function getSearchFinancialInstitutionsRequest() {
  return {
    type: SEARCH_FINANCIAL_INSTITUTION_REQUEST
  }
}

function getSearchFinancialInstitutionsSuccess(payload) {
  let financialInstitutions = {};

  if (!_isEmpty(payload)) {
    financialInstitutions = payload.institutions;
  }
  else if (!_isEmpty(payload.message)) {
    financialInstitutions = payload.message;
  }

  if (_isEmpty(financialInstitutions)) {
    financialInstitutions = {noResults: "No financial institutions retrieved."};
  }

  if (Array.isArray(financialInstitutions) && financialInstitutions.length === 0) {
    financialInstitutions = {noResults: "No financial institutions retrieved."};
  }

  return {
    type: SEARCH_FINANCIAL_INSTITUTION_SUCCESS,
    searchFinancialInstitutions: financialInstitutions
  }
}

function getSearchFinancialInstitutionsFailure() {
  return {
    type: SEARCH_FINANCIAL_INSTITUTION_FAILURE
  }
}

function financialInstitutionsByIdRequest() {
  return {
    type: FINANCIAL_INSTITUTIONS_BY_ID_REQUEST
  };
}

function financialInstitutionsByIdSuccess(payload) {
  let financialInstitutionsById = {};

  if (!_isEmpty(payload)) {
    financialInstitutionsById = payload;
  }
  else if (!_isEmpty(payload.message)) {
    financialInstitutionsById = payload.message;
  }

  if (_isEmpty(financialInstitutionsById)) {
    financialInstitutionsById = {noResults: "No financial institutions retrieved."};
  }

  return {
    type: FINANCIAL_INSTITUTIONS_BY_ID_SUCCESS,
    financialInstitutionsById
  };
}

function financialInstitutionsByIdFailure(error) {
  return {
    type: FINANCIAL_INSTITUTIONS_BY_ID_FAILURE,
    error,
  };
}

function popularFinancialInstitutionsRequest() {
  return {
    type: POPULAR_FINANCIAL_INSTITUTIONS_REQUEST
  };
}

function popularFinancialInstitutionsSuccess(payload) {
  let popularFinancialInstitutions = {};

  if (!_isEmpty(payload)) {
    popularFinancialInstitutions = payload.institutions;
  }
  else if (!_isEmpty(payload.message)) {
    popularFinancialInstitutions = payload.message;
  }

  if (_isEmpty(popularFinancialInstitutions)) {
    popularFinancialInstitutions = {noResults: "No popular financial institutions retrieved."};
  }

  return {
    type: POPULAR_FINANCIAL_INSTITUTIONS_SUCCESS,
    popularFinancialInstitutions
  };
}

function popularFinancialInstitutionsFailure(error) {
  return {
    type: POPULAR_FINANCIAL_INSTITUTIONS_FAILURE,
    error,
  };
}

function setTransactionAlertPrefRequest() {
  return {
    type: TXM_SET_ALERT_PREF_REQUEST,
  };
}

function setTransactionAlertPrefSuccess(payload) {
  if (!_isEmpty(payload)) {
    let alertPreference = [];
    alertPreference.push({
        symbol: 'GREATER_THAN',
        type: 'PURCHASE',
        value: _get(payload, 'preferences.transaction')
      },
      {
        symbol: 'GREATER_THAN',
        type: 'TRANSFER',
        value: _get(payload, 'preferences.transfer')
      },
      {
        symbol: 'GREATER_THAN',
        type: 'WITHDRAWAL',
        value: _get(payload, 'preferences.withdrawal')
      });
    return {
      type: TXM_SET_ALERT_PREF_SUCCESS,
      alertPreference
    };
  }
  return {
    type: TXM_SET_ALERT_PREF_FAILURE,
    error: _get(payload, 'txm.message', 'error')
  };
}

function setTransactionAlertPrefFailure() {
  return {
    type: TXM_SET_ALERT_PREF_FAILURE,
  };
}

// Utility action creators
function paginateTransactions(transactionList, startVal = 0, endVal) {
  let start = startVal;
  let end = endVal;
  let filteredTransactions = [];

  if (!_isEmpty(transactionList) && !transactionList.noResults) {
    if (transactionList.length <= end) {
      end = transactionList.length;
    }

    if (Array.isArray(transactionList)) {
      transactionList.forEach(() => {
        while (start < end) {
          filteredTransactions.push(transactionList[start++]);
        }
      });
    }
    else {
      filteredTransactions.push(transactionList);
    }
  }

  return {
    type: PAGINATE_TRANSACTIONS,
    paginatedTransactions: filteredTransactions
  }
}

function getTransactionsByAccountId(transactionList, accountId) {
  let filteredTransactions = [];

  if (!_isEmpty(transactionList) && !transactionList.noResults) {
    if (Array.isArray(transactionList)) {
      if (!_isEmpty(accountId) && accountId !== 'Accounts') {
        filteredTransactions = transactionList.filter((t) => {
          return t.accountId === accountId;
        });
      }
      else {
        filteredTransactions = transactionList;
      }
    }
    else if (transactionList.accountId === accountId || _isEmpty(accountId) || accountId === 'Accounts') {
      filteredTransactions.push(transactionList);
    }
  }

  return {
    type: FILTERED_TRANSACTIONS_BY_ACCOUNT_ID,
    filteredTransactionList: filteredTransactions
  }
}

// Yodlee Action Creators
function getAccessTokenRequest() {
  return {
    type: GET_ACCESS_TOKEN_REQUEST
  };
}

function getAccessTokenSuccess(payload) {
  return {
    type: GET_ACCESS_TOKEN_SUCCESS,
    getAccessTokenResult: payload
  };
}

function getAccessTokenFailure(error) {
  return {
    type: GET_ACCESS_TOKEN_ERROR,
    error
  };
}

/**
 * Calls addInstitutionLogin in the Transaction Monitoring WSDL.
 *
 * @param args
 * @param accountId
 *
 * @return {*}
 */
export function addInstitutionLogin(args, accountId) {
  let url = utils.getAddInstitutionLoginPath(args.isMock);
  const config = {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId
    },
    credentials: 'include',
    body: JSON.stringify(args)
  };
  return api(url, config, addInstitutionLoginRequest(), addInstitutionLoginSuccess, addInstitutionLoginFailure);
}

/**
 * Calls answerAddInstitutionLoginChallenge in the Transaction Monitoring WSDL.
 *
 * @param args
 * @return {*}
 */
export function answerAddInstitutionLoginChallenge(args, accountId) {
  let url = utils.getAnswerAddInstitutionLoginChallengePath(args.isMock);
  const config = {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId
    },
    credentials: 'include',
    body: JSON.stringify(args)
  };
  return api(url, config, answerAddInstitutionLoginChallengeRequest(), answerAddInstitutionLoginChallengeSuccess, answerAddInstitutionLoginChallengeFailure);
}

/**
 * Calls updateInstitutionLogin in the Transaction Monitoring WSDL.
 *
 * @param args
 * @return {*}
 */
export function updateInstitutionLogin(args, accountId) {
  let url = utils.getUpdateInstitutionLoginPath(args.isMock);
  const config = {
    method: 'put',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId
    },
    credentials: 'include',
    body: JSON.stringify(args)
  };
  return api(url, config, updateInstitutionLoginRequest(), updateInstitutionLoginSuccess, updateInstitutionLoginFailure);
}

/**
 * Calls answerUpdateInstitutionLoginChallenge in the Transaction Monitoring WSDL.
 *
 * @param args
 * @return {*}
 */
export function answerUpdateInstitutionLoginChallenge(args, accountId) {
  let url = utils.getAnswerUpdateInstitutionLoginChallengePath(args.isMock);
  const config = {
    method: 'put',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId
    },
    credentials: 'include',
    body: JSON.stringify(args)
  };
  return api(url, config, answerUpdateInstitutionLoginChallengeRequest(), answerUpdateInstitutionLoginChallengeSuccess, answerUpdateInstitutionLoginChallengeFailure);
}

/**
 * Calls deleteInstitutionLogin in the Transaction Monitoring WSDL.
 *
 * @param args
 * @return {*}
 */
export function deleteInstitutionLogin(args, accountId) {
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/institutionAccounts`;
  const config = {
    method: 'delete',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId
    },
    credentials: 'include',
    body: JSON.stringify(args)
  };
  return api(url, config, deleteInstitutionLoginRequest(), deleteInstitutionLoginSuccess, deleteInstitutionLoginFailure);
}

/**
 * Calls getAccountTransactions in the Transaction Monitoring WSDL.
 *
 * @param {Object} args
 * @param {string} args.memberId
 * @param {string} args.startDate
 * @param {string} args.endDate
 * @param {string} args.rowsToRetrieve
 * @param {string} args.institutionId
 * @param {string} args.accountId
 * @param {string} args.offset
 * @param {string} args.sortField
 * @param {string} args.sortOrder
 * @param {string} [testhost]
 *
 * @return {*} Returns the dispatch and state objects to the relevant reducer.
 */
export function getAccountTransactions(args, testhost, accountId) {
  const queryParam = queryString.stringify(args);
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}?${queryParam}`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'account_id': accountId
    },
    credentials: 'include'
  };
  if (args.isForOverview) {
    return api(url, config, transactionListRequest(), transactionListSuccess4Overview, transactionListFailure);
  }
  return api(url, config, transactionListRequest(), transactionListSuccess, transactionListFailure);
}

export function getInstitutionAccounts(args, testhost, accountId) {
  const queryParam = queryString.stringify(args);
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/institutionAccounts?${queryParam}`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'account_id': accountId
    },
    credentials: 'include'
  };
  return api(url, config, memberAccountsRequest(), memberAccountsSuccess, memberAccountsFailure);
}

export function getFinancialInstitutions(args, testhost, accountId) {
  const queryParam = queryString.stringify(args);
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/searchFinancialInstitutionsBySku?${queryParam}`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'account_id': accountId
    },
    credentials: 'include'
  };
  return api(url, config, financialInstitutionsRequest(), financialInstitutionsSuccess, financialInstitutionsFailure);
}

export function searchFinancialInstitutions(args, testhost, accountId) {
  const queryParam = queryString.stringify(args);
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/searchFinancialInstitutionsBySku?${queryParam}`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'account_id': accountId
    },
    credentials: 'include'
  };
  return api(url, config, getSearchFinancialInstitutionsRequest(), getSearchFinancialInstitutionsSuccess, getSearchFinancialInstitutionsFailure);
}

export function getFinancialInstitutionsById(args, testhost, accountId) {
  const queryParam = queryString.stringify(args);
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/financialInstitutionsById?${queryParam}`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'account_id': accountId
    },
    credentials: 'include'
  };
  return api(url, config, financialInstitutionsByIdRequest(), financialInstitutionsByIdSuccess, financialInstitutionsByIdFailure);
}

export function getPopularFinancialInstitutions(args, testhost, accountId) {
  const queryParam = queryString.stringify(args);
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/popularFinancialInstitutions?${queryParam}`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'account_id': accountId
    },
    credentials: 'include'
  };
  return api(url, config, popularFinancialInstitutionsRequest(), popularFinancialInstitutionsSuccess, popularFinancialInstitutionsFailure);
}

export function setTransactionAlertPreference(args, testhost, accountId) {
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/txmAlertPreference`;
  if (testhost) {
    url = testhost + url
  }
  const config = {
    method: 'put',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': utils.getCookieValue(document.cookie, 'XSRF-TOKEN'),
      'account_id': accountId
    },
    credentials: 'include',
    body: JSON.stringify(args)
  };
  return api(url, config, setTransactionAlertPrefRequest(), setTransactionAlertPrefSuccess, setTransactionAlertPrefFailure);
}

export function paginateTransactionList(transactionList, start, end) {
  return (dispatch) => {
    dispatch(paginateTransactions(transactionList, start, end));
  }
}

export function filterTransactionsByAccountId(transactionList, accountId) {
  return (dispatch) => {
    dispatch(getTransactionsByAccountId(transactionList, accountId));
  }
}

export function resetAddAccountsModal() {
  return (dispatch) => {
    dispatch({
      "type": RESET_ADD_ACCOUNTS_MODAL
    })
  }
}

export function resetLoginForm() {
  return (dispatch) => {
    dispatch({
      "type": RESET_LOGIN_FORM
    })
  }
}

export function resetLoginError(response) {
  if (response) {
    return (dispatch) => {
      dispatch({
        "type": RESET_LOGIN_ERROR,
        "statusCode": response.statusCode,
        "memSiteAccountId": response.memSiteAccountId
      })
    }
  }

  return (dispatch) => {
    dispatch({
      "type": RESET_LOGIN_ERROR
    })
  }
}

export function resetChallengeQuestions() {
  return (dispatch) => {
    dispatch({
      "type": RESET_CHALLENGE_QUESTION
    })
  }
}

export function getAccessToken() {
  let url = `${window.REACT_APP_MEMBER_API_HOST}${window.REACT_APP_TRANSACTIONS_PATH}/fastLinkToken`;
  const config = {
    method: 'get',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  };
  return api(url, config, getAccessTokenRequest(), getAccessTokenSuccess, getAccessTokenFailure);
}



// WEBPACK FOOTER //
// ./src/actions/transactionActions.js